document.addEventListener('DOMContentLoaded', () => {
  const section = document.getElementById('about-bento-section');
  if (!section) return;

  const slides = section.querySelectorAll('.onyx-bento-slide');
  const dots = section.querySelectorAll('.bento-dot');
  const prevBtn = document.getElementById('bentoPrev');
  const nextBtn = document.getElementById('bentoNext');
  const swipeArea = document.getElementById('onyxSwipeArea');
  const paginationContainer = document.getElementById('bentoPagination');
  
  if (!slides.length) return;

  let currentIndex = 0;
  const totalSlides = slides.length;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      requestAnimationFrame(() => {
        if (entry.isIntersecting) {
          section.classList.add('is-visible');
          setTimeout(() => {
            if (section.classList.contains('is-visible')) {
              section.classList.add('animations-finished');
            }
          }, 2200); 
        } else {
          section.classList.remove('is-visible', 'animations-finished');
        }
      });
    });
  }, { threshold: 0.15 }); 
  
  observer.observe(section);

  function updateSlider(index) {
    requestAnimationFrame(() => {
      // Opt: Clean specifically targeted nodes rather than iterating blindly
      section.querySelectorAll('.onyx-bento-slide.active, .onyx-bento-slide.prev, .onyx-bento-slide.next')
        .forEach(slide => slide.classList.remove('active', 'prev', 'next'));
      
      const activeDot = section.querySelector('.bento-dot.active');
      if (activeDot) activeDot.classList.remove('active');

      const prevIndex = (index - 1 + totalSlides) % totalSlides;
      const nextIndex = (index + 1) % totalSlides;

      slides[index].classList.add('active');
      slides[prevIndex].classList.add('prev');
      slides[nextIndex].classList.add('next');
      
      if(dots[index]) dots[index].classList.add('active');
      
      currentIndex = index;
    });
  }

  if (nextBtn) nextBtn.addEventListener('click', () => updateSlider((currentIndex + 1) % totalSlides));
  if (prevBtn) prevBtn.addEventListener('click', () => updateSlider((currentIndex - 1 + totalSlides) % totalSlides));

  if (paginationContainer) {
    paginationContainer.addEventListener('click', (e) => {
      if (e.target.classList.contains('bento-dot')) {
        const targetIndex = parseInt(e.target.getAttribute('data-target'), 10);
        if (!isNaN(targetIndex)) updateSlider(targetIndex);
      }
    });
  }

  let touchStartX = 0;
  let touchEndX = 0;

  if (swipeArea) {
    swipeArea.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    swipeArea.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
  }

  function handleSwipe() {
    const minSwipeDistance = 40; 
    if (touchStartX - touchEndX > minSwipeDistance) {
      updateSlider((currentIndex + 1) % totalSlides);
    } else if (touchEndX - touchStartX > minSwipeDistance) {
      updateSlider((currentIndex - 1 + totalSlides) % totalSlides);
    }
  }
});